/** Knitwear cues of the design system (DESIGN.md §4): refined, never cute. */

/** Section divider: a single row of tiny stitches. */
export function StitchRule({ className = '' }: { className?: string }) {
  return <div className={`stitch-rule ${className}`} aria-hidden="true" />;
}

const METER_TONE = {
  accent: 'stroke-accent',
  warning: 'stroke-warning',
  error: 'stroke-error',
} as const;

/**
 * Coverage meter drawn as a row of knit stitches that fills from the left: knitted stitches in
 * colour, the rest as faint loops still on the needle.
 */
export function StitchMeter({
  percent,
  label,
  title,
  tone = 'accent',
  stitches = 20,
}: {
  percent: number;
  label: string;
  title?: string;
  tone?: keyof typeof METER_TONE;
  stitches?: number;
}) {
  const clamped = Math.max(0, Math.min(100, percent));
  const done = Math.round((clamped / 100) * stitches);
  const W = 9;
  return (
    <svg
      role="meter"
      aria-valuemin={0}
      aria-valuemax={100}
      aria-valuenow={Math.round(clamped)}
      aria-label={label}
      viewBox={`0 0 ${stitches * W} 12`}
      className="block h-3 min-w-0 max-w-[13rem] flex-1"
      preserveAspectRatio="xMinYMid meet"
      data-testid="stitch-meter"
    >
      {title && <title>{title}</title>}
      {Array.from({ length: stitches }, (_, i) => {
        const x = i * W;
        const knitted = i < done;
        return (
          <path
            key={i}
            d={`M${x + 1.2} 1.5 Q${x + 1.9} 6.8 ${x + 4} 10.5 Q${x + 6.1} 6.8 ${x + 6.8} 1.5`}
            fill="none"
            strokeWidth={knitted ? 1.6 : 1.1}
            strokeLinecap="round"
            strokeLinejoin="round"
            className={knitted ? METER_TONE[tone] : 'stroke-line-strong'}
          />
        );
      })}
    </svg>
  );
}
